function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var ThemeModeStorage = /*#__PURE__*/ function() {
    "use strict";
    function ThemeModeStorage() {
        _class_call_check(this, ThemeModeStorage);
        _define_property(this, "storageKey", 'THEME_MODES');
    }
    _create_class(ThemeModeStorage, [
        {
            key: "getParsedValue",
            value: function getParsedValue() {
                var rawValue = localStorage.getItem(this.storageKey);
                if (!rawValue) return null;
                return JSON.parse(rawValue);
            }
        },
        {
            key: "get",
            value: function get(userId) {
                var parseValue = this.getParsedValue();
                if (parseValue) {
                    var _valueList_indexOfLargestValue;
                    var userValue = userId ? parseValue[userId] : null;
                    if (userValue) return userValue.themeMode;
                    var valueList = Object.values(parseValue);
                    var indexOfLargestValue = valueList.reduce(function(maxIndex, currentValue, currentIndex, array) {
                        var _array_maxIndex;
                        return (currentValue === null || currentValue === void 0 ? void 0 : currentValue.timeStamp) > ((_array_maxIndex = array[maxIndex]) === null || _array_maxIndex === void 0 ? void 0 : _array_maxIndex.timeStamp) ? currentIndex : maxIndex;
                    }, 0);
                    return (_valueList_indexOfLargestValue = valueList[indexOfLargestValue]) === null || _valueList_indexOfLargestValue === void 0 ? void 0 : _valueList_indexOfLargestValue.themeMode;
                }
                return null;
            }
        },
        {
            key: "set",
            value: function set(themeMode, userId) {
                var _this_getParsedValue;
                var parseValue = (_this_getParsedValue = this.getParsedValue()) !== null && _this_getParsedValue !== void 0 ? _this_getParsedValue : {};
                parseValue[userId] = {
                    timeStamp: new Date().getTime(),
                    themeMode: themeMode
                };
                localStorage.setItem(this.storageKey, JSON.stringify(parseValue));
            }
        }
    ]);
    return ThemeModeStorage;
}();
export var themeModeStorage = new ThemeModeStorage();
